module.exports = __webpack_public_path__ + "static/pic-profile-member-3-020d702a369a3a02a66819ef00a01b7c.png";